import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <h5 className="text-center text-light mb-4">
        © 2024 Copyright : <i className="text-info ">Wagdy Ashraf</i>{" "}
      </h5>
    );
  }
}
